/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-24T15:39:24-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-02-17T14:13:00-08:00
*/



import React, { Component } from 'react';
import glamorous from 'glamorous';
import Avatar from '../../common/Avatar';
import { dimensions } from '../../../style';

const ProfileImage = glamorous.div({
  borderRadius: '100%',
  cursor: 'pointer'
});

class MainPhoto extends Component {
  handleClick = e => {
    this.props.onClick(0, e);
  };

  render() {
    return (
      <ProfileImage onClick={this.handleClick}>
        <Avatar sex="male" src={this.props.avatar} />
      </ProfileImage>
    );
  }
}

export default MainPhoto;



// WEBPACK FOOTER //
// ./src/components/pages/Profile/MainPhoto.jsx